import React, { useState, useEffect }  from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook
import ProductButtons from "./ProductButtons"; // Подключаем кнопки
import { useLanguage } from "../i18n/LanguageContext";

import styles from "./Home.module.css";


function Home() {
    const { t } = useLanguage();

    const [viewportSize, setViewportSize] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    const navigate = useNavigate(); // React Router navigation function

    useEffect(() => {
      const updateSize = () => {
        setViewportSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };

      window.addEventListener("resize", updateSize);
      return () => window.removeEventListener("resize", updateSize);
    }, []);

  return (
    <div className={styles.container}>
      <div className={styles.logoWrapper}>
        {/* Логотип */}
        <img src="/assets/Logo_3.png" alt="Logo " className={styles.logo} />

        {/* Текст */}
        <div className={styles.text}>
          <h1>VALMIS DE LUXE</h1>
          {/* <p>Крупнейший импортер рыбной консервы</p>
          <p> на рынке Украины с 2009 года.</p> */}
          <div className={styles.buttons}>
            <button className={styles.yellowButton} onClick={() => navigate("/contact-us")}>{t("home.contactUs")}</button>
            <button className={styles.grayButton} onClick={() => navigate("/about-brand")} >{t("home.aboutBrand")}</button>
          </div>

          <ProductButtons />

        </div>
          {/* Вывод размеров экрана */}
          {process.env.NODE_ENV !== "production" && (
              <div className={styles.viewportInfo}>
                vw: {viewportSize.width} px | vh: {viewportSize.height} px
              </div>
            )}
        

        {/* <img src="/assets/all-product.png" alt="Products" className={styles.products} /> */}

        {/* Верхняя банка */}
        <img src="/assets/top-can.png" alt="Top Can" className={styles.topCan} />

        {/* Верхняя ПРАВАЯ банка */}
        <img src="/assets/top-can.png" alt="Top Can" className={styles.topCanRight} />

        {/* Нижняя банка */}
        <img src="/assets/bottom-can.png" alt="Bottom Can" className={styles.imageCan} />
      
      </div>
    </div>
  );
}

export default Home;
